@layer refine.base {
  :host {
    --_bg: var(--color-canvas);
    --_radius: var(--rounded-xl);

    position: relative;
    display: block;
    width: 100%;
    min-height: 240px;
    overflow: hidden;
    background: var(--_bg);
    border-radius: var(--_radius);
  }

  .track {
    position: absolute;
    inset-block: 0;
    inset-inline-start: 0;
    display: flex;
    flex-direction: row;
    gap: var(--marquee-gap, var(--size-4));
    align-items: stretch;
    width: max-content;
    animation: marquee-scroll var(--_marquee-duration, 20s) linear infinite;
    will-change: transform;
  }

  .controls {
    display: flex;
    gap: var(--size-0-5);
    align-items: center;
    pointer-events: none;
  }

  :host > .controls {
    position: absolute;
    inset-block-end: var(--size-3);
    inset-inline-end: var(--size-3);
    padding: var(--size-1-5) var(--size-2);
    background: color-mix(in oklch, var(--color-canvas) 55%, transparent);
    border-radius: var(--rounded-full);
    backdrop-filter: blur(6px);
  }

  .nav-btn {
    pointer-events: auto;
  }

  :host([direction='right']) .track {
    animation-direction: reverse;
  }

  :host([pause-on-hover]:hover) .track {
    animation-play-state: paused;
  }

  ::slotted(*) {
    position: relative;
    flex: 0 0 auto;
    height: 100%;
  }

  ::slotted([data-marquee-clone]) {
    pointer-events: none;
    user-select: none;
  }

  @keyframes marquee-scroll {
    from {
      transform: translateX(0);
    }

    to {
      transform: translateX(var(--_marquee-translate, -50%));
    }
  }
}

@media (prefers-reduced-motion: reduce) {
  .track {
    animation: none;
  }
}
